import React,{useState,useEffect} from 'react';
import {motion} from 'framer-motion';
import {useData} from '../../context/DataContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiX,FiCheck}=FiIcons;

const CreateIncidentModal=({onClose})=> {
  const [formData,setFormData]=useState({
    type: '',
    wardrobeName: '',
    locker: '',
    owner: '',
    employeeCode: '',
    description: '',
    responsible: '',
    priority: 'media',
    observations: '',
    // Campos adicionales para cambio de talla
    garmentType: '',
    currentSize: '',
    newSize: '',
    // Campos adicionales para cambio de grupo
    currentGroup: '',
    newGroup: '',
    // Campos adicionales para cambio de ubicación
    currentWardrobe: '',
    currentLocker: '',
    newWardrobe: '',
    newLocker: '',
    // Para prenda en mal estado
    selectedGarmentBarcode: '',
    // NUEVO: Para retirar prendas
    removalReason: '',
    // NUEVO: Para asignar prendas
    assignGarmentType: '',
    assignGarmentQuantity: '',
    assignGarmentCondition: ''
  });
  
  const [loading,setLoading]=useState(false);
  const {addIncident,inventoryData}=useData();
  
  // CORREGIDO: Función para ordenar vestuarios como en la pantalla principal
  const getWardrobeOrder=(wardrobeName)=> {
    const wardrobe=wardrobeName.toLowerCase();
    // V1-V14
    const vMatch=wardrobe.match(/^v(\d+)$/);
    if (vMatch) {
      const num=parseInt(vMatch[1]);
      if (num >=1 && num <=14) return num;
      if (num===18) return 15;
      if (num >=32 && num <=35) return 16 + (num - 32);
    }
    // V18
    if (wardrobe==='v18') return 15;
    // V32-V35
    if (wardrobe==='v32') return 16;
    if (wardrobe==='v33') return 17;
    if (wardrobe==='v34') return 18;
    if (wardrobe==='v35') return 19;
    // Nave 9
    if (wardrobe.includes('nave 9') || wardrobe.includes('nave9')) return 20;
    // Nave 11
    if (wardrobe.includes('nave 11') || wardrobe.includes('nave11')) return 21;
    // Otros vestuarios van al final
    return 1000;
  };
  
  // CORREGIDO: Función para ordenar taquillas numéricamente
  const getLockerOrder=(locker)=> {
    const numbers=locker.match(/\d+/g);
    if (numbers && numbers.length > 0) {
      return parseInt(numbers[0]);
    }
    return 9999;
  };
  
  // CORREGIDO: Vestuarios ordenados como en la pantalla principal
  const uniqueWardrobes=[...new Set(inventoryData.map(item=> item.wardrobeName).filter(Boolean))]
    .sort((a,b)=> {
      const orderA=getWardrobeOrder(a);
      const orderB=getWardrobeOrder(b);
      if (orderA !==orderB) {
        return orderA - orderB;
      }
      return a.localeCompare(b);
    });
  
  // CORREGIDO: Taquillas ordenadas numéricamente
  const uniqueLockers=formData.wardrobeName ? [...new Set(inventoryData.filter(item=> item.wardrobeName===formData.wardrobeName).map(item=> item.locker).filter(Boolean))]
    .sort((a,b)=> {
      const orderA=getLockerOrder(a);
      const orderB=getLockerOrder(b);
      if (orderA !==orderB) {
        return orderA - orderB;
      }
      return a.localeCompare(b);
    }) : [];
  
  // NUEVO: Todas las taquillas disponibles para el selector de destino
  const allLockers=formData.newWardrobe ? [...new Set(inventoryData.filter(item=> item.wardrobeName===formData.newWardrobe).map(item=> item.locker).filter(Boolean))]
    .sort((a,b)=> {
      const orderA=getLockerOrder(a);
      const orderB=getLockerOrder(b);
      if (orderA !==orderB) {
        return orderA - orderB;
      }
      return a.localeCompare(b);
    }) : [];
  
  const responsibleOptions=['Alex','Raúl'];
  
  const incidentTypes=[
    {value: 'cambio_talla',label: 'Cambio de talla'},
    {value: 'cambio_grupo',label: 'Cambio de grupo'},
    {value: 'cambio_ubicacion',label: 'Cambio de ubicación'},
    {value: 'prenda_mal_estado',label: 'Prenda en mal estado'},
    {value: 'retirar_prendas',label: 'Retirar prendas'},
    // NUEVO: Tipo de incidencia para asignar prendas
    {value: 'asignar_prendas',label: 'Asignar prendas'}
  ];
  
  // NUEVO: Opciones de causa para retirar prendas
  const removalReasons=[
    {value: 'baja_empresa',label: 'Baja de empresa'},
    {value: 'cambio_grupo',label: 'Cambio de grupo'},
    {value: 'prenda_mal_estado',label: 'Prenda en mal estado'},
    {value: 'otras',label: 'Otras'}
  ];
  
  // NUEVO: Tipos de prenda disponibles
  const garmentTypes=[
    {value: 'pantalon',label: 'Pantalón'},
    {value: 'camiseta',label: 'Camiseta'},
    {value: 'chaqueta',label: 'Chaqueta'},
    {value: 'calzado',label: 'Calzado'},
    {value: 'guantes',label: 'Guantes'},
    {value: 'casco',label: 'Casco'},
    {value: 'chaleco',label: 'Chaleco'},
    {value: 'mono',label: 'Mono'},
    {value: 'bufanda',label: 'Bufanda'},
    {value: 'gorro',label: 'Gorro'}
  ];
  
  // NUEVO: Condiciones de prenda
  const garmentConditions=[
    {value: '7000',label: 'Nueva (cod.7000)'},
    {value: '2000',label: 'Usada (cod.2000)'}
  ];
  
  // NUEVO: Obtener datos del usuario seleccionado
  const getUserData=()=> {
    if (!formData.wardrobeName || !formData.locker) return null;
    return inventoryData.find(item=> item.wardrobeName===formData.wardrobeName && item.locker===formData.locker );
  };
  
  // NUEVO: Obtener prendas únicas del usuario
  const getUserGarments=()=> {
    const userData=getUserData();
    if (!userData) return [];
    
    // Agrupar por tipo de prenda y talla
    const garmentMap=new Map();
    inventoryData.forEach(item=> {
      if (item.wardrobeName===formData.wardrobeName && item.locker===formData.locker && item.garment && item.size) {
        const key=`${item.garment}-${item.size}-${item.barcode}`;// Clave más única
        if (!garmentMap.has(key)) {
          garmentMap.set(key,{
            garment: item.garment,
            size: item.size,
            barcode: item.barcode
          });
        }
      }
    });
    
    return Array.from(garmentMap.values());
  };
  
  // NUEVO: Obtener todas las tallas disponibles para un tipo de prenda
  const getAllSizesForGarment=(garmentType)=> {
    if (!garmentType) return [];
    
    const sizes=new Set();
    inventoryData.forEach(item=> {
      if (item.garment===garmentType && item.size) {
        sizes.add(item.size);
      }
    });
    
    return Array.from(sizes).sort((a,b)=> {
      // Ordenar tallas numéricamente si es posible
      const aNum=parseInt(a.replace(/\D/g,''));
      const bNum=parseInt(b.replace(/\D/g,''));
      if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
      }
      return a.localeCompare(b);
    });
  };
  
  // NUEVO: Obtener talla actual para un tipo de prenda específico
  const getCurrentSizeForGarment=(garmentType)=> {
    const userGarment=getUserGarments().find(g=> g.garment===garmentType);
    return userGarment ? userGarment.size : '';
  };
  
  // NUEVO: Obtener todos los grupos disponibles en el sistema
  const getAllGroups=()=> {
    const groups=new Set();
    inventoryData.forEach(item=> {
      if (item.groupName && item.groupName.trim()) {
        groups.add(item.groupName.trim());
      }
    });
    return Array.from(groups).sort((a,b)=> a.localeCompare(b));
  };
  
  // NUEVO: Obtener grupo actual del usuario
  const getCurrentGroup=()=> {
    const userData=getUserData();
    return userData ? userData.groupName || '' : '';
  };
  
  const userGarments=getUserGarments();
  const availableSizes=formData.garmentType ? getAllSizesForGarment(formData.garmentType) : [];
  const availableGroups=getAllGroups();
  
  // NUEVO: Función para resetear campos específicos cuando cambia el tipo de incidencia
  const resetSpecificFields=()=> {
    setFormData(prev=> ({
      ...prev,
      // Resetear campos de cambio de talla
      garmentType: '',
      currentSize: '',
      newSize: '',
      // Resetear campos de cambio de grupo
      currentGroup: '',
      newGroup: '',
      // Resetear campos de cambio de ubicación
      currentWardrobe: '',
      currentLocker: '',
      newWardrobe: '',
      newLocker: '',
      // Resetear campo de prenda en mal estado
      selectedGarmentBarcode: '',
      // NUEVO: Resetear campo de retirar prendas
      removalReason: '',
      // NUEVO: Resetear campos de asignar prendas
      assignGarmentType: '',
      assignGarmentQuantity: '',
      assignGarmentCondition: '',
      // Resetear descripción para que se regenere
      description: ''
    }));
  };
  
  // NUEVO: Resetear campos específicos cuando cambia el tipo de incidencia
  useEffect(()=> {
    if (formData.type) {
      resetSpecificFields();
    }
  },[formData.type]);
  
  // Auto-fill user data when wardrobe and locker are selected
  useEffect(()=> {
    if (formData.wardrobeName && formData.locker) {
      const foundItem=inventoryData.find(
        item=> item.wardrobeName===formData.wardrobeName && item.locker===formData.locker
      );
      if (foundItem) {
        setFormData(prev=> ({
          ...prev,
          owner: foundItem.owner || '',
          employeeCode: foundItem.employeeCode || ''
        }));
      }
    }
  },[formData.wardrobeName,formData.locker,inventoryData]);
  
  // NUEVO: Auto-fill talla actual cuando se selecciona tipo de prenda
  useEffect(()=> {
    if (formData.type==='cambio_talla' && formData.garmentType) {
      const currentSize=getCurrentSizeForGarment(formData.garmentType);
      setFormData(prev=> ({
        ...prev,
        currentSize: currentSize,
        newSize: '' // Resetear nueva talla
      }));
    }
  },[formData.type,formData.garmentType]);
  
  // NUEVO: Auto-fill grupo actual cuando se selecciona cambio de grupo
  useEffect(()=> {
    if (formData.type==='cambio_grupo') {
      const currentGroup=getCurrentGroup();
      setFormData(prev=> ({
        ...prev,
        currentGroup: currentGroup
      }));
    }
  },[formData.type,formData.wardrobeName,formData.locker]);
  
  // NUEVO: Auto-fill ubicación actual cuando se selecciona cambio de ubicación
  useEffect(()=> {
    if (formData.type==='cambio_ubicacion') {
      const currentWardrobe=formData.wardrobeName || '';
      const currentLocker=formData.locker || '';
      setFormData(prev=> ({
        ...prev,
        currentWardrobe: currentWardrobe,
        currentLocker: currentLocker
      }));
    }
  },[formData.type,formData.wardrobeName,formData.locker]);
  
  // NUEVO: Auto-fill descripción para cambio de talla
  useEffect(()=> {
    if (formData.type==='cambio_talla' && formData.garmentType && formData.currentSize && formData.newSize) {
      const autoDescription=`Cambio de talla solicitado: ${formData.garmentType} de talla ${formData.currentSize} a talla ${formData.newSize}`;
      setFormData(prev=> ({
        ...prev,
        description: autoDescription
      }));
    }
  },[formData.type,formData.garmentType,formData.currentSize,formData.newSize]);
  
  // NUEVO: Auto-fill descripción para cambio de grupo
  useEffect(()=> {
    if (formData.type==='cambio_grupo' && formData.currentGroup && formData.newGroup) {
      const autoDescription=`Cambio de grupo solicitado: de ${formData.currentGroup} a ${formData.newGroup}`;
      setFormData(prev=> ({
        ...prev,
        description: autoDescription
      }));
    }
  },[formData.type,formData.currentGroup,formData.newGroup]);
  
  // NUEVO: Auto-fill descripción para cambio de ubicación
  useEffect(()=> {
    if (formData.type==='cambio_ubicacion' && formData.currentWardrobe && formData.currentLocker && formData.newWardrobe && formData.newLocker) {
      const autoDescription=`Cambio de ubicación solicitado: de ${formData.currentWardrobe}-${formData.currentLocker} a ${formData.newWardrobe}-${formData.newLocker}`;
      setFormData(prev=> ({
        ...prev,
        description: autoDescription
      }));
    }
  },[formData.type,formData.currentWardrobe,formData.currentLocker,formData.newWardrobe,formData.newLocker]);
  
  // NUEVO: Auto-fill descripción para prenda en mal estado
  useEffect(()=> {
    if (formData.type==='prenda_mal_estado' && formData.selectedGarmentBarcode) {
      const selectedGarment=userGarments.find(g=> g.barcode===formData.selectedGarmentBarcode);
      if (selectedGarment) {
        const autoDescription=`Reporte de prenda en mal estado: ${selectedGarment.garment} (Talla: ${selectedGarment.size},Código: ${selectedGarment.barcode}).`;
        setFormData(prev=> ({
          ...prev,
          description: autoDescription
        }));
      }
    }
  },[formData.type,formData.selectedGarmentBarcode,userGarments]);
  
  // NUEVO: Auto-fill descripción para retirar prendas
  useEffect(()=> {
    if (formData.type==='retirar_prendas' && formData.removalReason) {
      const reasonLabel=removalReasons.find(r=> r.value===formData.removalReason)?.label || formData.removalReason;
      const autoDescription=`Retirada de prendas solicitada. Motivo: ${reasonLabel}.`;
      setFormData(prev=> ({
        ...prev,
        description: autoDescription
      }));
    }
  },[formData.type,formData.removalReason]);
  
  // NUEVO: Auto-fill descripción para asignar prendas
  useEffect(()=> {
    if (formData.type==='asignar_prendas' && formData.assignGarmentType && formData.assignGarmentQuantity && formData.assignGarmentCondition) {
      const garmentLabel=garmentTypes.find(g=> g.value===formData.assignGarmentType)?.label || formData.assignGarmentType;
      const conditionLabel=garmentConditions.find(c=> c.value===formData.assignGarmentCondition)?.label || formData.assignGarmentCondition;
      const autoDescription=`Asignación de prendas solicitada: ${formData.assignGarmentQuantity} ${garmentLabel} (${conditionLabel}).`;
      setFormData(prev=> ({
        ...prev,
        description: autoDescription
      }));
    }
  },[formData.type,formData.assignGarmentType,formData.assignGarmentQuantity,formData.assignGarmentCondition]);
  
  const handleChange=(field,value)=> {
    setFormData(prev=> ({
      ...prev,
      [field]: value
    }));
  };
  
  const handleSubmit=async (e)=> {
    e.preventDefault();
    
    // Validación básica
    if (!formData.type || !formData.wardrobeName || !formData.locker) {
      return;
    }
    
    // Validación específica para cambio de talla
    if (formData.type==='cambio_talla') {
      if (!formData.garmentType || !formData.currentSize || !formData.newSize) {
        return;
      }
      if (formData.currentSize===formData.newSize) {
        return;
      }
    }
    
    // Validación específica para cambio de grupo
    if (formData.type==='cambio_grupo') {
      if (!formData.currentGroup || !formData.newGroup) {
        return;
      }
      if (formData.currentGroup===formData.newGroup) {
        return;
      }
    }
    
    // Validación específica para cambio de ubicación
    if (formData.type==='cambio_ubicacion') {
      if (!formData.currentWardrobe || !formData.currentLocker || !formData.newWardrobe || !formData.newLocker) {
        return;
      }
      if (formData.currentWardrobe===formData.newWardrobe && formData.currentLocker===formData.newLocker) {
        return;
      }
    }
    
    // Validación específica para prenda en mal estado
    if (formData.type==='prenda_mal_estado') {
      if (!formData.selectedGarmentBarcode) {
        return;
      }
    }
    
    // NUEVO: Validación específica para retirar prendas
    if (formData.type==='retirar_prendas') {
      if (!formData.removalReason) {
        return;
      }
    }
    
    // NUEVO: Validación específica para asignar prendas
    if (formData.type==='asignar_prendas') {
      if (!formData.assignGarmentType || !formData.assignGarmentQuantity || !formData.assignGarmentCondition) {
        return;
      }
      // Validar que la cantidad sea un número positivo
      const quantity=parseInt(formData.assignGarmentQuantity);
      if (isNaN(quantity) || quantity <=0) {
        return;
      }
    }
    
    setLoading(true);
    
    try {
      let garmentDetailsData=null;
      
      if (formData.type==='cambio_talla') {
        garmentDetailsData={
          garmentType: formData.garmentType,
          currentSize: formData.currentSize,
          newSize: formData.newSize
        };
      } else if (formData.type==='prenda_mal_estado') {
        const selectedGarment=userGarments.find(g=> g.barcode===formData.selectedGarmentBarcode);
        garmentDetailsData=selectedGarment ? {...selectedGarment} : null;
      }
      
      // Añadir datos adicionales según el tipo de incidencia
      const incidentData={
        ...formData,
        title: `${incidentTypes.find(t=> t.value===formData.type)?.label} - ${formData.wardrobeName}-${formData.locker}`,
        category: formData.type,
        garmentDetails: garmentDetailsData,
        // Datos adicionales para cambio de grupo
        groupDetails: formData.type==='cambio_grupo' ? {
          currentGroup: formData.currentGroup,
          newGroup: formData.newGroup
        } : null,
        // Datos adicionales para cambio de ubicación
        locationDetails: formData.type==='cambio_ubicacion' ? {
          currentWardrobe: formData.currentWardrobe,
          currentLocker: formData.currentLocker,
          newWardrobe: formData.newWardrobe,
          newLocker: formData.newLocker
        } : null,
        // NUEVO: Datos adicionales para retirar prendas
        removalDetails: formData.type==='retirar_prendas' ? {
          reason: formData.removalReason,
          reasonLabel: removalReasons.find(r=> r.value===formData.removalReason)?.label || ''
        } : null,
        // NUEVO: Datos adicionales para asignar prendas
        assignDetails: formData.type==='asignar_prendas' ? {
          garmentType: formData.assignGarmentType,
          garmentLabel: garmentTypes.find(g=> g.value===formData.assignGarmentType)?.label || '',
          quantity: formData.assignGarmentQuantity,
          condition: formData.assignGarmentCondition,
          conditionLabel: garmentConditions.find(c=> c.value===formData.assignGarmentCondition)?.label || ''
        } : null
      };
      
      await addIncident(incidentData);
      onClose();
    } catch (error) {
      console.error('Error creating incident:',error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <motion.div
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <motion.div
        initial={{scale: 0.9,opacity: 0}}
        animate={{scale: 1,opacity: 1}}
        exit={{scale: 0.9,opacity: 0}}
        className="bg-white rounded-xl shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto"
        onClick={e=> e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-xl">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-800">Nueva Incidencia</h3>
            <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 transition-colors">
              <SafeIcon icon={FiX} />
            </button>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Tipo de incidencia */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tipo de incidencia *
            </label>
            <select
              value={formData.type}
              onChange={e=> handleChange('type',e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
              required
            >
              <option value="">Seleccionar tipo...</option>
              {incidentTypes.map(type=> (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
          
          {/* Vestuario */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Vestuario *
            </label>
            <select
              value={formData.wardrobeName}
              onChange={e=> handleChange('wardrobeName',e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
              required
            >
              <option value="">Seleccionar vestuario...</option>
              {uniqueWardrobes.map(wardrobe=> (
                <option key={wardrobe} value={wardrobe}>
                  {wardrobe}
                </option>
              ))}
            </select>
          </div>
          
          {/* Taquilla */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Taquilla *
            </label>
            <select
              value={formData.locker}
              onChange={e=> handleChange('locker',e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
              required
              disabled={!formData.wardrobeName}
            >
              <option value="">
                {!formData.wardrobeName ? 'Primero selecciona vestuario' : 'Seleccionar taquilla...'}
              </option>
              {uniqueLockers.map(locker=> (
                <option key={locker} value={locker}>
                  {locker}
                </option>
              ))}
            </select>
          </div>
          
          {/* Usuario encontrado */}
          {(formData.owner || formData.employeeCode) && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-sm font-medium text-blue-800 mb-2">Usuario encontrado:</p>
              <div className="text-sm text-blue-700">
                {formData.owner && <p className="mb-1">Nombre: {formData.owner}</p>}
                {formData.employeeCode && <p>Nº empleado: {formData.employeeCode}</p>}
              </div>
            </div>
          )}
          
          {/* NUEVO: Campos específicos para Cambio de Talla */}
          {formData.type==='cambio_talla' && (
            <div className="space-y-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-red-800 mb-3">Detalles del Cambio de Talla</h4>
              
              {/* Tipo de prenda */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de prenda *
                </label>
                <select
                  value={formData.garmentType}
                  onChange={e=> handleChange('garmentType',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                >
                  <option value="">Seleccionar prenda...</option>
                  {userGarments.map((garment,index)=> (
                    <option key={index} value={garment.garment}>
                      {garment.garment} (Talla: {garment.size})
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Talla actual - Solo texto informativo */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Talla actual
                </label>
                <div className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700">
                  {formData.currentSize || 'Selecciona un tipo de prenda'}
                </div>
              </div>
              
              {/* Nueva talla */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nueva talla *
                </label>
                <select
                  value={formData.newSize}
                  onChange={e=> handleChange('newSize',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                  disabled={!formData.garmentType}
                >
                  <option value="">Seleccionar nueva talla...</option>
                  {availableSizes.map((size,index)=> (
                    <option key={index} value={size} disabled={size===formData.currentSize}>
                      {size} {size===formData.currentSize && '(actual)'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          
          {/* NUEVO: Campos específicos para Cambio de Grupo */}
          {formData.type==='cambio_grupo' && (
            <div className="space-y-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-red-800 mb-3">Detalles del Cambio de Grupo</h4>
              
              {/* Grupo actual - Solo texto informativo */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Grupo actual
                </label>
                <div className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700">
                  {formData.currentGroup || 'No hay grupo asignado'}
                </div>
              </div>
              
              {/* Nuevo grupo */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nuevo grupo *
                </label>
                <select
                  value={formData.newGroup}
                  onChange={e=> handleChange('newGroup',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                  disabled={!formData.wardrobeName || !formData.locker}
                >
                  <option value="">Seleccionar nuevo grupo...</option>
                  {availableGroups.map((group,index)=> (
                    <option key={index} value={group} disabled={group===formData.currentGroup}>
                      {group} {group===formData.currentGroup && '(actual)'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          
          {/* NUEVO: Campos específicos para Cambio de Ubicación */}
          {formData.type==='cambio_ubicacion' && (
            <div className="space-y-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-red-800 mb-3">Detalles del Cambio de Ubicación</h4>
              
              {/* Ubicación actual - Solo texto informativo */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ubicación actual
                </label>
                <div className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700">
                  {formData.currentWardrobe && formData.currentLocker ? `${formData.currentWardrobe} - ${formData.currentLocker}` : 'Selecciona vestuario y taquilla'}
                </div>
              </div>
              
              {/* Nueva ubicación - Vestuario destino */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Vestuario destino *
                </label>
                <select
                  value={formData.newWardrobe}
                  onChange={e=> handleChange('newWardrobe',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                  disabled={!formData.wardrobeName || !formData.locker}
                >
                  <option value="">Seleccionar vestuario destino...</option>
                  {uniqueWardrobes.map(wardrobe=> (
                    <option key={wardrobe} value={wardrobe} disabled={wardrobe===formData.currentWardrobe}>
                      {wardrobe} {wardrobe===formData.currentWardrobe && '(actual)'}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Nueva ubicación - Taquilla destino */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Taquilla destino *
                </label>
                <select
                  value={formData.newLocker}
                  onChange={e=> handleChange('newLocker',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                  disabled={!formData.newWardrobe}
                >
                  <option value="">
                    {!formData.newWardrobe ? 'Primero selecciona vestuario destino' : 'Seleccionar taquilla destino...'}
                  </option>
                  {allLockers.map(locker=> (
                    <option key={locker} value={locker} disabled={formData.newWardrobe===formData.currentWardrobe && locker===formData.currentLocker}>
                      {locker} {formData.newWardrobe===formData.currentWardrobe && locker===formData.currentLocker && '(actual)'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          
          {/* NUEVO: Campos específicos para Prenda en mal estado */}
          {formData.type==='prenda_mal_estado' && (
            <div className="space-y-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-red-800 mb-3">Detalles de la Prenda Afectada</h4>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Selecciona la prenda *
                </label>
                {userGarments.length > 0 ? (
                  <div className="space-y-2">
                    {userGarments.map((garment,index)=> (
                      <label
                        key={index}
                        className="flex items-center p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 has-[:checked]:bg-red-100 has-[:checked]:border-red-300 transition-colors"
                      >
                        <input
                          type="radio"
                          name="selectedGarment"
                          value={garment.barcode}
                          checked={formData.selectedGarmentBarcode===garment.barcode}
                          onChange={e=> handleChange('selectedGarmentBarcode',e.target.value)}
                          className="h-4 w-4 text-red-500 border-gray-300 focus:ring-red-500"
                        />
                        <div className="ml-3 text-sm">
                          <p className="font-medium text-gray-900">{garment.garment} (Talla: {garment.size})</p>
                          <p className="text-gray-500">Código: {garment.barcode}</p>
                        </div>
                      </label>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500 p-3 bg-white rounded-lg">No hay prendas asignadas a este usuario.</p>
                )}
              </div>
            </div>
          )}
          
          {/* NUEVO: Campos específicos para Retirar Prendas */}
          {formData.type==='retirar_prendas' && (
            <div className="space-y-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-red-800 mb-3">Detalles de la Retirada</h4>
              
              {/* Motivo de la retirada */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Motivo de la retirada *
                </label>
                <select
                  value={formData.removalReason}
                  onChange={e=> handleChange('removalReason',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                >
                  <option value="">Seleccionar motivo...</option>
                  {removalReasons.map(reason=> (
                    <option key={reason.value} value={reason.value}>
                      {reason.label}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Información de prendas asignadas */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Prendas asignadas al usuario
                </label>
                {userGarments.length > 0 ? (
                  <div className="bg-white border border-gray-200 rounded-lg p-3">
                    <p className="text-sm text-gray-600 mb-2">
                      El usuario tiene {userGarments.length} prenda{userGarments.length !==1 ? 's' : ''} asignada{userGarments.length !==1 ? 's' : ''}:
                    </p>
                    <ul className="space-y-1">
                      {userGarments.map((garment,index)=> (
                        <li key={index} className="text-sm text-gray-700">
                          • {garment.garment} (Talla: {garment.size},Código: {garment.barcode})
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                    <p className="text-sm text-yellow-700">
                      No hay prendas asignadas a este usuario.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          
          {/* NUEVO: Campos específicos para Asignar Prendas */}
          {formData.type==='asignar_prendas' && (
            <div className="space-y-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-red-800 mb-3">Detalles de la Asignación</h4>
              
              {/* Tipo de prenda */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de prenda *
                </label>
                <select
                  value={formData.assignGarmentType}
                  onChange={e=> handleChange('assignGarmentType',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                >
                  <option value="">Seleccionar tipo de prenda...</option>
                  {garmentTypes.map(garment=> (
                    <option key={garment.value} value={garment.value}>
                      {garment.label}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Cantidad de prendas */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Número de prendas *
                </label>
                <input
                  type="number"
                  min="1"
                  value={formData.assignGarmentQuantity}
                  onChange={e=> handleChange('assignGarmentQuantity',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  placeholder="Ej: 2"
                  required
                />
              </div>
              
              {/* Condición de las prendas */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Condición de las prendas *
                </label>
                <select
                  value={formData.assignGarmentCondition}
                  onChange={e=> handleChange('assignGarmentCondition',e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                >
                  <option value="">Seleccionar condición...</option>
                  {garmentConditions.map(condition=> (
                    <option key={condition.value} value={condition.value}>
                      {condition.label}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Información de prendas asignadas actualmente */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Prendas asignadas actualmente al usuario
                </label>
                {userGarments.length > 0 ? (
                  <div className="bg-white border border-gray-200 rounded-lg p-3">
                    <p className="text-sm text-gray-600 mb-2">
                      El usuario tiene {userGarments.length} prenda{userGarments.length !==1 ? 's' : ''} asignada{userGarments.length !==1 ? 's' : ''}:
                    </p>
                    <ul className="space-y-1">
                      {userGarments.map((garment,index)=> (
                        <li key={index} className="text-sm text-gray-700">
                          • {garment.garment} (Talla: {garment.size},Código: {garment.barcode})
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                    <p className="text-sm text-yellow-700">
                      No hay prendas asignadas a este usuario.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          
          {/* Descripción */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Descripción
            </label>
            <textarea
              value={formData.description}
              onChange={e=> handleChange('description',e.target.value)}
              placeholder="Describe detalladamente la incidencia..."
              rows={3}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          
          {/* Responsable */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Responsable
            </label>
            <select
              value={formData.responsible}
              onChange={e=> handleChange('responsible',e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              <option value="">Persona asignada...</option>
              {responsibleOptions.map(option=> (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          
          {/* Prioridad */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Prioridad
            </label>
            <div className="flex space-x-3">
              {['Baja','Media','Alta'].map(priority=> (
                <label key={priority} className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="priority"
                    value={priority.toLowerCase()}
                    checked={formData.priority===priority.toLowerCase()}
                    onChange={e=> handleChange('priority',e.target.value)}
                    className="text-red-500 focus:ring-red-500"
                  />
                  <span className="text-sm text-gray-700">{priority}</span>
                </label>
              ))}
            </div>
          </div>
          
          {/* Botones */}
          <div className="pt-4 space-y-3">
            <button
              type="button"
              onClick={onClose}
              className="w-full px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full transition-colors font-semibold"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={
                loading || 
                !formData.type || 
                !formData.wardrobeName || 
                !formData.locker || 
                (formData.type==='cambio_talla' && (!formData.garmentType || !formData.currentSize || !formData.newSize)) || 
                (formData.type==='cambio_grupo' && (!formData.currentGroup || !formData.newGroup)) || 
                (formData.type==='cambio_ubicacion' && (!formData.currentWardrobe || !formData.currentLocker || !formData.newWardrobe || !formData.newLocker)) || 
                (formData.type==='prenda_mal_estado' && !formData.selectedGarmentBarcode) || 
                (formData.type==='retirar_prendas' && !formData.removalReason) ||
                (formData.type==='asignar_prendas' && (!formData.assignGarmentType || !formData.assignGarmentQuantity || !formData.assignGarmentCondition))
              }
              className="w-full px-4 py-3 bg-red-500 hover:bg-red-600 disabled:bg-gray-300 text-white rounded-full transition-colors flex items-center justify-center space-x-2 font-semibold"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Creando...</span>
                </>
              ) : (
                <>
                  <SafeIcon icon={FiCheck} />
                  <span>Crear Incidencia</span>
                </>
              )}
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
};

export default CreateIncidentModal;